import React from 'react';
import {useParams} from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import logoImg from '../images/interagency-logo.jpg'

import { nameFromUrl } from '../lib/strFormatting'

import SelectLocation from './SelectLocation';
import SelectRegion from './SelectRegion';
import Link from './Link'

import './Header.css'

export default function RegionPageHeader(props){
    let { region } = useParams();
    let regionPretty = nameFromUrl(region)

    return (
        <Navbar expand="md">
            <Navbar.Brand href="/tracking/air-quality/">
                <img src={logoImg} width="100px" alt="" />
                <span>Air Quality Tracking</span>
            </Navbar.Brand>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Link className="nav-link" to="/tracking/air-quality">Home</Link>
                    <Link className="nav-link" to="/tracking/air-quality/about">About</Link>
                </Nav>
                {!props.noRegionSelector && (
                    <div className="d-none d-lg-block">
                        <SelectRegion
                            region={regionPretty}
                            header="Change Region" small={true}
                            rootUrl="/tracking/air-quality/" />
                    </div>
                )}
            </Navbar.Collapse>
        </Navbar>
    )
}